var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex mb-4"},[_c('div',{staticClass:"flex-grow-1"}),(_vm.hasAccess && _vm.isAdmin)?_c('select-hospital',{attrs:{"hospitals":_vm.hospitals}}):(_vm.hasAccess)?_c('Add',{on:{"click":function($event){return _vm.open()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }